import { render, staticRenderFns } from "./PresentacioView.vue?vue&type=template&id=55bcc6e4"
import script from "./PresentacioView.vue?vue&type=script&lang=js"
export * from "./PresentacioView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports